<template>
	<v-wall :backImg='backImg'>
		<p slot='title'>公司介绍</p>
		<div class="intro-content">
			<h3 class='intro-title'>北京绿汽科技有限公司</h3>
			<p class="intro-text">北京绿汽科技有限公司有着丰富的汽车 、互联网及金融行业经验团队，在围绕着汽车产业开展业务的过程中推出了汽车金融类产品，迅速打开局面获取营业数据、专业、强大的执行团队的基础上，做出了更具前瞻性的汽车金融类产品。而北京绿汽科技有限公司拥有独立研发并拥有独立知识产权系统及风险控制体系AI智能系统，目前已合作润东、维辰、金阳光、远通等经销商集团共700余家4S店，利用本系统可完全解决经销商集团4S店开展二手车业务的痛点，迅速占领市场并与同业展开紧密优质的合作。</p>
			<div class='intro-imgs'>
				<div class='intro-check'>
					<img src="../../assets/images/image-1.jpg">
					<div class='intro-imgs-cover'>查估设备</div>
				</div>
				<div class='intro-work'>
					<img src="../../assets/images/image-2.jpg">
					<div class='intro-imgs-cover'>查估作业</div>
				</div>
			</div>
			<div class='intro-workers'>
				<img src="../../assets/images/image-3.jpg">
				<div class='intro-imgs-cover'>门店展示</div>
			</div>
			<p>线下店面</p>
			<p class="intro-content-text"> 截至2016年，已发展9家线下直营门店与6家加盟店，包含：直营门店（徐州、南通、临沂、湖州、嘉兴、淮安、淄博、威海、泰安）。加盟店（济南、阜阳、西安、济宁、瑞安、盐城）。自2015年4Q至今，评估超过6万余台实车，均为完整车况（影像、结构、OBD等）及从收购到交易全过程掌握最高价值数据，远程查估服务已遍及700家以上4S店、金融机构及半数以上第三方平台。同时也积极拓展全国各省份SP代理及直营/加盟店。</p>
		</div>
	</v-wall>
</template>

<script>
  import backImg from '../../assets/images/img_bg_03.jpg'
  export default {
    data () {
      return {
        backImg: backImg
      }
    }
  }
</script>

<style lang='scss' scoped>
	.intro-content {
		padding: 92px 168px;
		text-align: left;font-size: 18px;
		color: #666666;
		letter-spacing: 0;
		.intro-title {
			font-size: 32px;
			color: #222328;
			letter-spacing: 0;
			line-height: 36px;
			font-weight: 500;
			margin-bottom: 47px;
		}
		.intro-text {
			font-size: 18px;
			color: #666666;
			letter-spacing: 0;
			line-height: 34px;
			margin-bottom: 44px;
		}
		.intro-imgs {
			display: flex;
			justify-content: space-between;
			.intro-check, .intro-work {
				width: 48%;
				min-width: 360px;
				min-height: 240px;
				position: relative;
				overflow: hidden;
				border-radius: 6px;
				font-size: 0;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		.intro-workers {
			margin: 25px 0 44px;
			position: relative;
			font-size: 0;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.intro-content-text {
			margin: 31px 0 41px;
			font-size: 18px;
			color: #666666;
			letter-spacing: 0;
			line-height: 34px;
		}
	    .intro-imgs-cover {
			height: 48px;
			width: 100%;
			background-color: rgba(0, 0, 0, .3);
			position: absolute;
			bottom: 0;
			border-radius: 0 0 6px 6px;
			color: #fff;
			line-height: 48px;
			padding-left: 30px;
			font-size: 14px;
		}
	}
</style>



// WEBPACK FOOTER //
// Intro.vue?ffe36806